export class BorderRadiusGroupModel {
    constructor(
        public readonly topLeft: number,
        public readonly topRight: number,
        public readonly bottomRight: number,
        public readonly bottomLeft: number,
    ) {
    }
}
